import React,{useState} from 'react'
import { toast } from 'react-toastify'
import Modal from '../../../components/Modal'
import { TOAST_CONFIG } from '../../../config/constants'

export default function UpdateStatus({data,onSubmit,setData,setModal}) {

    // const [data,setData] = useState({status:0,reason:'',description:''})
    const [loading,setLoading] = useState(false)

  return (
    <Modal title="Update Status" size="md">
        <form name='updateStatus' className="modal-inner-content">
            <div className='input-group'>
            <label>Status</label>
            <select value={data.status} defaultChecked={data.status} required onChange={(e)=>setData(prev=>({...prev,status:e.target.value}))}>
                        <option value={0}>Open</option>
                        <option value={1}>Closed</option>
                    </select>
        </div>
        <div className='input-group'>
            <label>Reason</label>
            <select value={data.reason} defaultChecked={data.reason} required onChange={(e)=>setData(prev=>({...prev,reason:e.target.value}))}>
                <option value=''></option>
                <option value='alreadyRegistered'>Already Registered</option>
                <option value='notInterested'>Not Interested</option>
                <option value='other'>Other</option>
            </select>
        </div>
        <div>
            <label>Description</label>
            <textarea rows={3} draggable={false} value={data.reasonDescription} required className="text-input" style={{'resize':'none'}} onChange={(e)=>setData(prev=>({...prev,reasonDescription:e.target.value}))}/>
        </div>
        </form>
        <div className="modal-footer">
            <button type='button' className="xs-neutral-btn" onClick={()=>setModal(false)}>Cancel</button>
            <button form='updateStatus' className="xs-delete-btn" type='submit' onClick={onSubmit} disabled={loading}>Update</button>
        </div>
    </Modal>
  )
}
